import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { ArrowLeft, Pencil, Trash2 } from 'lucide-react';

import { ColorPicker, stringToHexColor } from 'categories/Components/ColorPicker'
import BulkAddOptions from './BulkAddOptions'
import EditOption from './EditOption'
import GroupOptionsModal from './GroupOptionsModal'
import AssignParentsModal from './AssignParentsModal'

const Options = (props) => {
    const { 
            // surveyStructureId,
            optionItem,
            setShowOptions,
            setSubfactorList,
            setShowSubFactors,
            surveyStrucRow,
            setSurveyStrucRow,
            loading,
            setUpdateJsonFile,
         } = props

    const [listName, setListName] = useState('')
    const [surveyOptions, setSurveyOptions] = useState([])
    const [openBulkOptions, setOpenBulkOptions] = useState(false)
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [itemToDelete, setItemToDelete] = useState(false)
    const [editOpen, setEditOpen] = useState(false)
    const [optionToEdit, setOptionToEdit] = useState(null)
    const [openGroupModal, setOpenGroupModal] = useState(false)
    const [openAssignParents, setOpenAssignParents] = useState(false)
    // const [loading, setLoading] = useState(false)

    // const [updatedRows, setUpdatedRows] = useState(false)
    const [color, setColor] = useState('#BCBCBC')

    useEffect(() => {
        setSurveyOptions(optionItem?.options)
    }, [optionItem]);

    function UpdatedOptionItem(e) {
        setListName(e.target.value)
        setColor(stringToHexColor(e.target.value, 50, 60))
    }

    function AddToList() {
        // setLoading(true)
        const _survey = surveyOptions
        if (listName.length > 0) {
            _survey.push({
                id: uuidv4(),
                name: listName,
                fr: '',
                description: '',
                color: color,
            })

        }
        setSurveyOptions(_survey)
        setListName('')

        const ExcludedList = surveyStrucRow.filter(sc => sc.id !== optionItem.id)
        optionItem.options = _survey
        ExcludedList.push(optionItem)

        setSurveyStrucRow(ExcludedList)
        setUpdateJsonFile(Math.random())
    }

    console.log(optionItem)
    // {
    //     "id": "7269967e-0526-4b91-a78b-f49c75f9abcb",
    //     "name": "Gender",
    //     "input": "ask_if_not_found",
    //     "options": [

    //     "priority": "tertiary",
    //     "question": "What is your gender? Gender refers to current gender which may be different from sex assigned at birth and may be different from what is indicated on legal documents",
    //     "subtitle": "Gender",
    //     "subfactors": [],
    //     "visibility": "private"
    // }

    function RemoveFromList() {
        // console.log(itemToDelete)
        setConfirmOpen(false)
        // setLoading(true)
        const _survey = surveyOptions.filter(sc => sc.id !== itemToDelete.id)
        setSurveyOptions(_survey)

        const ExcludedList = surveyStrucRow.filter(sc => sc.id !== optionItem.id)
        optionItem.options = _survey
        ExcludedList.push(optionItem)

        setSurveyStrucRow(ExcludedList)
        setUpdateJsonFile(Math.random())
    }

    function PreviousPage() {
        setShowOptions(false)
    }

    function SetSubFactor(items) {
        // console.log(items)
        setSubfactorList(items)
        setShowSubFactors(true)
    }

    function ConfirmDeleteItem(e) {
        // console.log(e)
        setConfirmOpen(true)
        setItemToDelete(e)
    }

    function ResetDeleteItem() {
        setConfirmOpen(false)
        setItemToDelete(false)
    }

    function OpenEdit(item) {
        setOptionToEdit(item)
        setEditOpen(true)
    }
    return (
        <>
            <div className="mb-4 flex items-center gap-3">
                <button
                    onClick={PreviousPage}
                    className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back
                </button>
                <div className="text-sm text-gray-500">
                    <span className="font-medium text-gray-700">{optionItem?.name}</span>
                    <span className="mx-2">•</span>
                    <span className="font-mono">{optionItem?.id}</span>
                </div>
            </div>

            <div className="relative rounded-lg border border-gray-200 bg-white p-4 shadow-sm md:p-6">
                {loading && (
                    <div className="absolute inset-0 z-10 grid place-items-center bg-white/60 backdrop-blur-sm">
                        <div className="h-6 w-6 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" />
                    </div>
                )}

                <div className="overflow-x-auto">
                    <table className="min-w-full table-auto border-collapse">
                        <thead>
                            <tr className="border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
                                <th className="px-3 py-2">Id</th>
                                <th className="px-3 py-2">Option Name</th>
                                <th className="px-3 py-2">Description</th>
                                <th className="px-3 py-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {surveyOptions && surveyOptions.map((item, i) => (
                                <tr key={item?.id || i} className="border-b border-gray-100 hover:bg-gray-50">
                                    <td className="px-3 py-2 align-top font-mono text-xs text-gray-500">{item?.id}</td>
                                    <td className="px-3 py-2 align-top text-sm text-gray-800">{item?.name}</td>
                                    <td className="px-3 py-2 align-top text-sm text-gray-600">{item?.description || ''}</td>
                                    <td className="px-3 py-2 align-top">
                                        <div className="flex items-center gap-2">
                                            <button
                                                type="button"
                                                onClick={() => ConfirmDeleteItem(item)}
                                                className="inline-flex items-center justify-center rounded-md border border-red-200 bg-white p-2 text-red-600 hover:bg-red-50"
                                                aria-label="Delete option"
                                            >
                                                <Trash2 className="h-4 w-4" />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => OpenEdit(item)}
                                                className="inline-flex items-center justify-center rounded-md border border-gray-200 bg-white p-2 text-gray-700 hover:bg-gray-50"
                                                aria-label="Edit option"
                                            >
                                                <Pencil className="h-4 w-4" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-4 grid items-center gap-3 md:grid-cols-[1fr_auto_auto_auto_auto]">
                    <input
                        className="h-10 w-full rounded-md border border-gray-300 px-3 text-sm outline-none ring-offset-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                        placeholder="New Option Name"
                        name="name"
                        value={listName}
                        onChange={(e) => UpdatedOptionItem(e)}
                    />

                    <div className="flex h-10 items-center">
                        <ColorPicker
                            color={color}
                            setColor={(c) => setColor(c.hex)}
                        />
                    </div>

                    <button
                        onClick={AddToList}
                        className="inline-flex h-10 items-center justify-center rounded-md bg-blue-600 px-4 text-sm font-medium text-white hover:bg-blue-700"
                    >
                        Add +
                    </button>
                    <button
                        onClick={() => setOpenBulkOptions(true)}
                        className="inline-flex h-10 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    >
                        Bulk Add
                    </button>
                    <button
                        onClick={() => setOpenGroupModal(true)}
                        className="inline-flex h-10 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    >
                        Manage Groups
                    </button>
                    <button
                        onClick={() => setOpenAssignParents(true)}
                        className="inline-flex h-10 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50"
                    >
                        Assign Parents
                    </button>
                </div>

                <AlertDialog.Root open={confirmOpen} onOpenChange={setConfirmOpen}>
                    <AlertDialog.Portal>
                        <AlertDialog.Overlay className="fixed inset-0 z-40 bg-black/30" />
                        <AlertDialog.Content className="fixed left-1/2 top-1/2 z-50 w-[95vw] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border border-gray-200 bg-white p-6 shadow-lg">
                            <AlertDialog.Title className="text-base font-semibold text-gray-900">
                                Warning: Irreversible action
                            </AlertDialog.Title>
                            <AlertDialog.Description className="mt-2 text-sm text-gray-600">
                                This will delete this option and its associated sub factors. This cannot be reversed. Are you sure?
                            </AlertDialog.Description>
                            <div className="mt-6 flex items-center justify-end gap-3">
                                <AlertDialog.Cancel asChild>
                                    <button
                                        onClick={ResetDeleteItem}
                                        className="inline-flex h-9 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                </AlertDialog.Cancel>
                                <AlertDialog.Action asChild>
                                    <button
                                        onClick={RemoveFromList}
                                        className="inline-flex h-9 items-center justify-center rounded-md bg-red-600 px-4 text-sm font-medium text-white hover:bg-red-700"
                                    >
                                        Delete
                                    </button>
                                </AlertDialog.Action>
                            </div>
                        </AlertDialog.Content>
                    </AlertDialog.Portal>
                </AlertDialog.Root>

                <BulkAddOptions
                    open={openBulkOptions}
                    setOpen={setOpenBulkOptions}
                    optionItem={optionItem}
                    existingOptions={surveyOptions}
                    setSurveyOptions={setSurveyOptions}
                    surveyStrucRow={surveyStrucRow}
                    setSurveyStrucRow={setSurveyStrucRow}
                    setUpdateJsonFile={setUpdateJsonFile}
                />
                <EditOption
                    open={editOpen}
                    setOpen={setEditOpen}
                    option={optionToEdit}
                    surveyOptions={surveyOptions}
                    setSurveyOptions={setSurveyOptions}
                    optionItem={optionItem}
                    surveyStrucRow={surveyStrucRow}
                    setSurveyStrucRow={setSurveyStrucRow}
                    setUpdateJsonFile={setUpdateJsonFile}
                />
                <GroupOptionsModal
                    open={openGroupModal}
                    setOpen={setOpenGroupModal}
                    existingOptions={surveyOptions}
                    setSurveyOptions={setSurveyOptions}
                    optionItem={optionItem}
                    surveyStrucRow={surveyStrucRow}
                    setSurveyStrucRow={setSurveyStrucRow}
                    setUpdateJsonFile={setUpdateJsonFile}
                />
                <AssignParentsModal
                    open={openAssignParents}
                    setOpen={setOpenAssignParents}
                    existingOptions={surveyOptions}
                    setSurveyOptions={setSurveyOptions}
                    optionItem={optionItem}
                    surveyStrucRow={surveyStrucRow}
                    setSurveyStrucRow={setSurveyStrucRow}
                    setUpdateJsonFile={setUpdateJsonFile}
                />
            </div>
        </>
    );
};

export default Options;